/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2019, Zumper
 * @description PreserveFiltersLink Component
 */

import { createAllowedPropsAreEqual } from '@zcode/react-utils'
import { rootRelative } from '@zcode/utils'
import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { Link } from 'react-router-dom'

const PreserveFiltersLink = ({
  'aria-level': ariaLevel,
  children,
  className,
  onClick,
  onMouseEnter,
  role,
  to,
}) => {
  return (
    <Link
      aria-level={ariaLevel}
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      role={role}
      to={rootRelative(to)}
    >
      {children}
    </Link>
  )
}

PreserveFiltersLink.propTypes = {
  'aria-level': PropTypes.number,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  role: PropTypes.string,
  to: PropTypes.string.isRequired,
}

const equalProps = ['children', 'className', 'onClick', 'onMouseEnter', 'to']

const areEqual = createAllowedPropsAreEqual(equalProps)

export default memo(PreserveFiltersLink, areEqual)
